module.exports = "/_next/static/images/Frame@2x-d8f0acd6151c5252364e41dce5837789.png";